import axios from 'axios';

const state = {
  settings: [] // This holds the settings data
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings;
  },
};

const actions = {
  async fetchSettings({ commit }) {
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
      return null; // Handle no token case
    }

    const savedId = localStorage.getItem('userId');
    if (!savedId) {
      console.error('No user ID found in local storage.');
      return null; // Handle no user ID
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      const response = await axios.get(`${baseUrl}/users/${savedId}/settings`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      console.log('API Response:', response.data);
  
      if (response.data) {
        const settingsArray = [
          { label: 'language', value: response.data.language },
          { label: 'dark_mode', value: response.data.dark === 1 ? 'Enabled' : 'Disabled' },
          { label: 'show_inactive_products', value: response.data.show_inactive_products === 1 ? 'Enabled' : 'Disabled' },
          { label: 'show_inactive_locations', value: response.data.show_inactive_locations === 1 ? 'Enabled' : 'Disabled' },
          { label: 'other', value: response.data.other }
        ];
        commit('setSettings', response.data); // Store the raw settings
        return response.data; // Return the raw settings
      } else {
        console.error('No settings found in API response.');
        return null; 
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error; // Propagate the error
    }
  },

  async updateSettings({ commit }, settings) { // Ensure this action exists
    const userToken = localStorage.getItem('userToken');
    const savedId = localStorage.getItem('userId');

    if (!userToken || !savedId) {
      return; // Handle missing credentials
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      const response = await axios.put(`${baseUrl}/users/${savedId}/settings`, settings, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      console.log('Update Response:', response.data); // Log response
      return response.data; // Return update confirmation if needed
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error; // Propagate error
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};